export default __webpack_public_path__ + "static/media/badgeBB.b57779ab.png";